import { Route } from '@angular/router';
import { AuthUrlParts, maintenanceGuard, unauthenticatedGuard } from '@examdojo/auth';

export const authRoutes: Route[] = [
  {
    path: AuthUrlParts.Login,
    data: { animation: 'SignInPage' },
    canActivate: [maintenanceGuard, unauthenticatedGuard],
    loadComponent: () => import('@examdojo/auth').then((c) => c.StudentSignInComponent),
  },
  {
    path: AuthUrlParts.Register,
    data: { animation: 'SignUpPage' },
    canActivate: [maintenanceGuard, unauthenticatedGuard],
    loadComponent: () => import('@examdojo/auth').then((c) => c.StudentSignUpComponent),
  },
  {
    path: AuthUrlParts.Otp,
    data: { animation: 'OtpPage' },
    canActivate: [maintenanceGuard, unauthenticatedGuard],
    loadComponent: () => import('@examdojo/auth').then((c) => c.SignInOTPComponent),
  },
];
